"use client"

import React from "react"
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  VKIcon,
  VKShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "next-share"

import { cn } from "@/lib/utils"

interface SocialMediaShareProps extends React.HTMLAttributes<HTMLDivElement> {
  url: string
  hashtag: string
  title: string
}
export default function SocialMediaShare({
  url,
  hashtag,
  title,
  className,
}: SocialMediaShareProps) {
  // set to production url in dev mode for testing
  if (process.env.NODE_ENV === "development") {
    const urlObj = new URL(url)
    url = `https://www.uniquenamegenerators.com${urlObj.pathname}${urlObj.search}${urlObj.hash}`
  }
  return (
    <div className={cn("flex gap-x-4", className)}>
      <div
        className="transition-transform hover:scale-110"
        data-attr-generator-social="vk"
      >
        <VKShareButton url={url} title={title}>
          <VKIcon size={32} round />
        </VKShareButton>
      </div>
      <div
        className="transition-transform hover:scale-110"
        data-attr-generator-social="telegram"
      >
        <TelegramShareButton url={url} title={title} id="telegram">
          <TelegramIcon size={32} round />
        </TelegramShareButton>
      </div>
      <div
        className="transition-transform hover:scale-110"
        data-attr-generator-social="facebook"
      >
        <FacebookShareButton url={url} hashtag={hashtag} title={title}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </div>
      <div
        className="transition-transform hover:scale-110"
        data-attr-generator-social="whatsapp"
      >
        <WhatsappShareButton url={url} title={title}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </div>
    </div>
  )
}
